import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const componentState = (state: RootState) => state.component.addNoteModal;

export const isCreating = createSelector(componentState, ({ createLoading }) => createLoading);
